@use '@lib/assets/styles/main.scss' as *;
.questionFormEmptyStateRoot {
  //margin-bottom: 32px;
}

.questionFormEmptyState {
  border-radius: 8px;
  border: 1px dashed $gray200;
  padding: 16px 24px;
  text-align: center;
  transition: border 0.3s ease, background 0.3s ease;
}

.questionFormEmptyStateActive {
  border: 1px dashed $gray500;
  background: $gray50;
}

.questionFormEmptyStateHasError {
  border: 1px dashed $error900;
}

.questionFormEmptyStateTitle {
  color: $gray500;
  margin-bottom: 8px;
}

.questionFormEmptyStateText {
  color: $gray400;
}
